import "core-js/modules/es.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { useEffect } from 'react';
import i18n from '@pureartisan/simple-i18n';
import clsx from 'clsx';
import { MdClose } from 'react-icons/md';
import useStore from './../store.js';
import PanelFilterView from './../PanelFilterView/PanelFilterView';
import PanelLayersView from './../PanelLayersView/PanelLayersView';
import PanelInfoView from './../PanelInfoView/PanelInfoView';
import { CoreButton } from './../../../core';

var SlideoutPanel = function SlideoutPanel(_ref) {
  var props = _extends({}, _ref); // Generic store value setter.


  var setStoreValues = useStore(function (state) {
    return state.setStoreValues;
  });
  var slideoutPanel = useStore(function (state) {
    return state.slideoutPanel;
  });

  var handleClose = function handleClose() {
    // console.log('handleClose')
    var panelState = slideoutPanel;
    panelState.active = false; // Set focus on the clicked button.

    var panelBtnId = 'button_toggle_panel_' + slideoutPanel.panel;
    var panelBtn = document.getElementById(panelBtnId);
    panelBtn.focus(); // Update store.

    setStoreValues({
      slideoutPanel: _extends({}, panelState)
    });
  }; // Toggle focus and tabindex on slideout panel when active.


  useEffect(function () {
    // console.log('Slideout panel active state changed.')
    var closeBtn = document.getElementById('button_close_panel'); // console.log('closeBtn, ', closeBtn)

    if (!!closeBtn) {
      if (!!slideoutPanel.active) {
        closeBtn.setAttribute('tabindex', '0');
        closeBtn.focus();
      } else {
        closeBtn.setAttribute('tabindex', '-1');
      }
    }
  }, [slideoutPanel.active]);
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('map-panel-slideout', slideoutPanel.active ? 'active' : '', slideoutPanel.panel.length > 0 ? 'panel-view-' + slideoutPanel.panel : 'panel-view-none')
  }, /*#__PURE__*/React.createElement(CoreButton, {
    id: "button_close_panel",
    label: i18n.translate("BUTTON_CLOSE_PANEL"),
    onClick: handleClose,
    color: "none",
    className: clsx('button-core', 'button-close-panel'),
    tabIndex: "-1"
  }, /*#__PURE__*/React.createElement(MdClose, null), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, i18n.translate("BUTTON_CLOSE_PANEL"))), /*#__PURE__*/React.createElement(PanelFilterView, null), /*#__PURE__*/React.createElement(PanelLayersView, null), /*#__PURE__*/React.createElement(PanelInfoView, null));
};

export default SlideoutPanel;